import { render, staticRenderFns } from "./RelationshipApprovalRequest.vue?vue&type=template&id=19fddd9a&scoped=true"
import script from "./RelationshipApprovalRequest.vue?vue&type=script&lang=js"
export * from "./RelationshipApprovalRequest.vue?vue&type=script&lang=js"
import style0 from "./RelationshipApprovalRequest.vue?vue&type=style&index=0&id=19fddd9a&prod&lang=css"
import style1 from "./RelationshipApprovalRequest.vue?vue&type=style&index=1&id=19fddd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fddd9a",
  null
  
)

export default component.exports